import React from 'react'
import useCurrentUser from '../../../hooks/use-current-user'
import DimensionsBarGraph from '../dimensions-bar-graph'
import Spinner from '../../common/spinner-container'

const ProgressScreen = () => {
    const { isBusy, id } = useCurrentUser()

    if (isBusy) {
        return ( <Spinner />)
    }

    return (
        <DimensionsBarGraph userId={id} />
    )
}

export default ProgressScreen